<template>
  <div id="swiper">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in numArr" :key="index">
          <div class="item" :style="getStyle(index)"></div>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <!-- <div class="swiper-pagination"></div> -->
      
      <!-- 如果需要导航按钮 -->
      <!-- <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div> -->
      
      <!-- 如果需要滚动条 -->
      <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
  
</template>

<script type="text/ecmascript-6">
import 'swiper/dist/css/swiper.css'
import Swiper from "swiper"

export default {
  data() {
    return {
      mySwiper: null,
      numArr: [
        require('../assets/img/0.png'),
        require('../assets/img/1.png'),
        require('../assets/img/2.png'),
        require('../assets/img/3.png'),
        require('../assets/img/4.png'),
        require('../assets/img/5.png'),
        require('../assets/img/6.png'),
        require('../assets/img/7.png'),
        require('../assets/img/8.png'),
        require('../assets/img/9.png'),
      ]
    }
  },
  mounted () {
    this.swiperInit()
  },
  methods: {
    getIndex(){
      return this.mySwiper.realIndex
    },
    swiperInit(){
      let vm = this
      this.mySwiper = new Swiper('.swiper-container', {
        // initialSlide: 1,
        direction: 'vertical',
        loop: true,
        slidesPerView: 3
      })
    },
    getStyle(index) {
      return `background-image:url(${this.numArr[index]})`
    }
  }
}

</script>

<style scoped lang="stylus">
  #swiper 
    width: 20vw
    height: 200px
    background-image: url(../assets/img/codeBg.png)
    background-size: 100% 100%
    .swiper-container
      height: 100%
      .swiper-slide
        .item 
          height: 100% - 20px
          // box-sizing: border-box
          margin: 10px 0
          background-position: center 
          background-repeat: no-repeat
          background-size: contain
</style>


// WEBPACK FOOTER //
// src/components/slide.vue